import { Moment } from "moment";
import { OfficeEntity } from "@features/desks/services/AdvanceHotDeskingService";
import { agent } from "@shared/services/agent";
import { DATE_FORMAT } from "@shared/utils/DateUtils";


export function getMeetingRoomUsageForOffice(office: OfficeEntity | undefined, dateFrom: Moment, dateTo: Moment): Promise<MeetingRoomUsageReport> {
  const officeParam = office ? `officeId=${office.id}&` : '';
  return agent.requests.get(`/api/report/meeting-rooms/usage?${officeParam}fromDate=${dateFrom.format(DATE_FORMAT)}&toDate=${dateTo.format(DATE_FORMAT)}`);
}

export interface MeetingRoomUsageLine {
  roomId: string;
  roomName: string;
  officeId: number | null;
  officeLabel: string | null;
  capacity: number;
  totalBookings: number;
  totalHoursBooked: number;
  averageBookingHours: number;
  utilizationPercentage: number;
}

export interface MeetingRoomDailyUsage {
  date: string;
  bookings: number;
  hoursBooked: number;
}

export interface MeetingRoomUsageReport {
  officeId: number | null;
  officeLabel: string;
  workingDaysInRange: number;
  totalBookings: number;
  totalHoursBooked: number;
  utilizationPercentage: number;
  rooms: MeetingRoomUsageLine[];
  dailyBreakdown: MeetingRoomDailyUsage[];
}
